import React, {useEffect, useState} from 'react';
import {render} from "./utils/render";
import {useMediaQuery} from "react-responsive";
import {mobileMediaQuery, tabletHorizontalMediaQuery, tabletVerticalMediaQuery} from "./utils/media-queries";
import Slider from "react-slick";
import {fetchProductGroups} from "./api/product-group";

const initSearchFieldClickListener = () => {
  const isMobile = window.innerWidth < 768;

  if (!isMobile) {
    return;
  }

  const searchFieldContainer = document.querySelector('.search-input-container');
  const searchField = document.querySelector('.search-input-container input');
  const searchAllProductsContainer = document.querySelector('.search-all-products-container.mobile-flex');

  if (searchField && searchAllProductsContainer) {
    // Hide the icons when the input field receives focus
    searchField.addEventListener('focus', function (event) {
      searchAllProductsContainer.classList.add('hide-search-icons');
      searchFieldContainer.classList.add('expand-search-input-container');
    });

    // Show the icons when the input field loses focus
    searchField.addEventListener('blur', function (event) {
      searchAllProductsContainer.classList.remove('hide-search-icons');
      searchFieldContainer.classList.remove('expand-search-input-container');
    });
  } else {
    console.warn('One or more elements not found.');
  }
}

const SupplementsTrendContainer = ({fetchFunction, scoreType}) => {
  const isMobile = useMediaQuery(mobileMediaQuery());
  const isTabletH = useMediaQuery(tabletHorizontalMediaQuery());
  const isTabletV = useMediaQuery(tabletVerticalMediaQuery());

    const productGroups = [

        {
            "id": 15,
            "name": "Vitamin B7 (Biotin)",
            "nameShort": "Biotin (B7) ",
            "link": "/produktsuche/vitamin-b7"
        },
        {
            "id": 22,
            "name": "Eisen (Fe)",
            "nameShort": "Eisen",
            "link": "/produktsuche/eisen"
        },
        {
            "id": 16,
            "name": "Vitamin B9 (Folsäure, Folat)",
            "nameShort": "Folsäure (B9)",
            "link": "/produktsuche/vitamin-b9"
        },
        {
            "id": 60,
            "name": "Kollagen",
            "nameShort": "Kollagen",
            "link": "/produktsuche/kollagen"
        },
        {
            "id": 30,
            "name": "Magnesium (Mg)",
            "nameShort": "Magnesium",
            "link": "/produktsuche/magnesium"
        },
        {
            "id": 54,
            "name": "Omega 3",
            "nameShort": "Omega 3",
            "link": "/produktsuche/omega%203"
        },
        {
            "id": 27,
            "name": "Proteine (Eiweiß) ",
            "nameShort": "Proteine",
            "link": "/produktsuche/proteine"
        },
        {
            "id": 41,
            "name": "Vitamin Q (Coenzym Q10)",
            "nameShort": "Q10",
            "link": "/produktsuche/vitamin-q"
        },
        {
            "id": 18,
            "name": "Vitamin C (Ascorbinsäure)",
            "nameShort": "Vitamin C",
            "link": "/produktsuche/vitamin-c"
        },
        {
            "id": 4,
            "name": "Vitamin D",
            "nameShort": "Vitamin D",
            "link": "/produktsuche/vitamin-d"
        },
        {
            "id": 10,
            "name": "Zink (Zn)",
            "nameShort": "Zink",
            "link": "/produktsuche/zink"
        }

    ];

    const settings = {
        dots: false,
        infinite: true,
        autoplay: false,
        speed: 500,
        slidesToShow: isTabletV ? isTabletH ? 4 : 5 : 4,
        slidesToScroll: 1,
        arrows: false,
        mobileFirst: true,
        variableWidth: true,
        swipeToSlide: true
    };

  return (isMobile || isTabletV) && (
    <div>
      <Slider {...settings}>
        {productGroups.map(productGroup => {
          let shortName;
          if (productGroup.nameShort) {
            shortName = productGroup.nameShort;
          } else {
            shortName = productGroup.name.substring(0, productGroup.name.indexOf('(') === -1 ? productGroup.name.length : productGroup.name.indexOf('('));
          }

          return (
            <div key={productGroup.id}>
              <a href={productGroup.link}>{shortName}</a>
            </div>
          )
        })}
      </Slider>
    </div>
  );
};

render(<SupplementsTrendContainer/>, 'supplementsTrendContainerMobile');
initSearchFieldClickListener();






